import { Notification } from "api/resources/notifications/types"
import { useEffect, useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import { NotificationURLParam } from "utils/constants"

import { useNotificationAction } from "./useNotificationAction"

export function useAutomaticNotificationAction() {
  const [searchParams, setSearchParams] = useSearchParams()

  const notification: Notification | null = useMemo(() => {
    const encoded = searchParams.get(NotificationURLParam)

    if (!encoded) return null

    try {
      return JSON.parse(encoded)
    } catch (err) {
      console.error("Failed to parse notification from URL", err)
      return null
    }
  }, [searchParams])

  const { handleNotificationClick } = useNotificationAction(notification)

  useEffect(() => {
    if (handleNotificationClick) handleNotificationClick()

    if (searchParams.has(NotificationURLParam)) {
      const newParams = new URLSearchParams(searchParams)
      newParams.delete(NotificationURLParam)
      setSearchParams(newParams, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleNotificationClick, searchParams])
}
